'use client';

import React from 'react';

import { Heading, Stack, Box } from '@chakra-ui/react';
import { useRouter } from 'next/navigation';

import { CustomText } from '@components/Custom-text';
import FAQSection from '@modules/home/component/sections/Faq';
import LinearImages from '@modules/home/component/sections/LinearImages';
import { paths } from '@routes/path';
import { newStepsData } from '@utils/data';

import { HowItWorksStepOne } from '../stepone/HowItWorksStepOne';

export const HowItWorksView = () => {
    const router = useRouter();
    const handleMentee = () => {
        router.push(paths.mentee.auth.signup);
    };
    return (
        <Box py={{ base: 4, md: 20 }}>
            <Stack spacing={4} alignItems="Center" marginBottom={4}>
                <Heading color="primary.dark" size="2xl">
                    How It Works
                </Heading>
                <CustomText color="shadowSlate" size="md" textAlign="center" maxWidth="70%">
                    Select from our pool of expert mentors and check their availability. Book your
                    1v1 sessions at convenient times, and receive personalized guidance to
                    accelerate your career growth.
                </CustomText>
            </Stack>

            {newStepsData.map((step, index) => (
                <HowItWorksStepOne key={index} {...step} />
            ))}
            <LinearImages
                heading="Learn and Grow With Help From World-class Mentors"
                buttonLabel="Signup as Mentee"
                onClick={handleMentee}
            />
            <FAQSection />
        </Box>
    );
};
